/* istanbul ignore file */

export enum MapContext {
    MapPage = 'MapPage',
    SitePage = 'SitePage',
    DashboardPage = 'DashboardPage',
}
